<template lang="pug">
.broken-banner
  img(src="aaiainanaeasdivaaaaa.png" :width="width" :height="height")
</template>

<style lang="scss" scoped>
.broken-banner {
  position: relative;
  display: inline-block;
  background-color: #fff;
  img {
    display: block;
  }
  &:before,
  &:after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    background-repeat: no-repeat;
    background-size: contain;
  }
  &:before {
    left: 0;
    width: 22px;
    height: 15px;
    // background-image: image-url('ad-tip@2x.png');
  }
  &:after {
    right: 0;
    width: 19px;
    height: 10px;
    background-image: image-url("ad-icon@2x.png");
  }
}
</style>

<script>
export default {
  name: "broken-banner",
  props: {
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    }
  }
};
</script>
